import i18next from "i18next";
import { initReactI18next } from "react-i18next";
import fi from '../../../translations/fi.json';
import en from '../../../translations/en.json';

const resources = {
  en: { translation: { ...en } },
  fi: { translation: { ...fi } }
};

export type supportedLanguagesType = keyof typeof resources;
export const supportedLanguages = Object.keys(resources) as (keyof typeof resources)[];
// type for languages
export type LanguagesType = {
  [key in supportedLanguagesType]: {
    name: string;
    flag: string;
  };
};
export const languages: LanguagesType = {
  fi: {
    name: "Suomeksi",
    flag: "fi"
  },
  en: {
    name: "In English",
    flag: "en"
  }
};

const i18nInstance = i18next.createInstance();

i18nInstance
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    resources,
    lng: "fi",
    fallbackLng: "fi",
    interpolation: {
      escapeValue: false // react already safes from xss
    }
  });

export default i18nInstance;
